import React, { useState, useEffect, useContext } from 'react';
import { Search, User, Calendar, ChevronLeft, ChevronRight } from 'lucide-react';
import '../../../assets/css/Buyer/blogs/blogs.css';
import MyNavbar from 'components/Buyer/navbar/MyNavbar';
import Footer from 'components/Buyer/footer/Footer';
import HeroSection from 'subscreens/general/pageheros/HeroSection';
import { useCol } from 'react-bootstrap/esm/Col';
import AppContext from 'context/AppContext';
import axios from 'axios';

const Blogs = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const { baseUrl, baseUrlForFiles ,authToken} = useContext(AppContext);
  const [visibleBlogs, setVisibleBlogs] = useState(3);
  const [selectedCategory, setSelectedCategory] = useState('');
  // const [currentSlide, setCurrentSlide] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [showFullContent, setShowFullContent] = useState(false);
  const viewAllBuyerBlogs = () => {
    axios
      .post(`${baseUrl}/buyer/buyerblogs/viewAllBuyerBlogs`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        setBlogPosts(response.data.blogs || []);
        console.log(response.data.blogs);

      })
      .catch((error) => {
        console.log(error);

      });


  };

  useEffect(() => {
    viewAllBuyerBlogs();
  }, []);
  const loadMoreBlogs = () => {
    setVisibleBlogs((prev) => prev + 5);
  };


  const tags = [
    'family',
    'investment',
    'rentals',
    'mortgage',
    'commercial',
    'sales',
    'property',
    'land-sale'
  ];
  const categories = [
    ...new Set(
      blogPosts.map((post) => post.category)
    )
  ];
  const latestBlogs = [...blogPosts]
    .reverse()
    .slice(0, 3);
  const filteredBlogs = selectedCategory
    ? blogPosts.filter(
      (post) => post.category === selectedCategory
    )
    : blogPosts;

  // Handle blog click
  const handleBlogClick = (post) => {
    setSelectedBlog(post);
    setShowFullContent(true);
    window.scrollTo({ top: 400, behavior: 'smooth' });
  };

  // Handle latest news click
  const handleNewsClick = (newsId) => {
    const blog = blogPosts.find(post => post.id === newsId);
    if (blog) {
      handleBlogClick(blog);
    }
  };

  // Handle tag click
  const handleTagClick = (tag) => {
    const matchingBlog = blogPosts[0];
    handleBlogClick(matchingBlog);
  };

  // Close full content
  const closeFullContent = () => {
    setShowFullContent(false);
    setSelectedBlog(null);
  };

  return (
    <>
      <MyNavbar />
      <div className="blog-page">
        {/* Hero  Section */}
        <HeroSection
          title="Our Blogs"
          subtitle="EXplore More Blogs and latest news"
          // label="Professional Team"
          image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920"
        // align="left"
        // size="lg"
        />

        

        {/* Main Content */}
        <div className="blog-main-content">
          {/* Show Full Blog Content or List */}
          {showFullContent && selectedBlog ? (
            /* Full Blog Content View */
            <div className="full-blog-content">
              <button className="back-to-blogs-btn Poppins-Medium" onClick={closeFullContent}>
                <ChevronLeft size={20} />
                Back to All Blogs
              </button>

              <article className="full-blog-article">
                <div className="full-blog-image">
                  <img src={`${baseUrlForFiles}${selectedBlog.image}`} alt={selectedBlog.title} />
                </div>

                <h1 className="full-blog-title Baloo2-Bold">{selectedBlog.title}</h1>

                <div className="full-blog-meta Poppins-Regular">
                  <span className="blog-author">
                    {/* <User size={16} /> */}
                    {selectedBlog.category}
                  </span>
                  <span className="blog-date">
                    {/* <Calendar size={16} /> */}
                    {selectedBlog.description}
                  </span>
                </div>

                <div
                  className="full-blog-body Poppins-Regular"
                  dangerouslySetInnerHTML={{ __html: selectedBlog.fullContent }}
                />

                <div className="blog-tags-section">
                  <h4 className="Poppins-Medium">Tags:</h4>
                  <div className="blog-tags-list">
                    {tags.slice(0, 5).map((tag, index) => (
                      <span key={index} className="blog-tag Poppins-Regular">{tag}</span>
                    ))}
                  </div>
                </div>
              </article>
            </div>
          ) : (
            /* Blog Posts List */
            <div className="blog-posts-section">
              {filteredBlogs.slice(0, visibleBlogs).map((post) => (
                <article key={post.id} className="blog-post-card">
                  <div className="blog-post-image" onClick={() => handleBlogClick(post)}>
                    <img src={`${baseUrlForFiles}${post.image}`} alt={post.title} />
                  </div>
                  <div className="blog-post-content">
                    <h2
                      className="blog-post-title Baloo2-Medium"
                      onClick={() => handleBlogClick(post)}
                    >
                      {post.title}
                    </h2>
                    <div className="blog-post-meta Poppins-Regular">
                      <span className="blog-author">
                        {/* <User size={14} /> */}
                        {post.category}
                      </span>
                      <span className="blog-date">
                        {/* <Calendar size={14} /> */}
                        {post.description}
                      </span>
                    </div>
                    <p className="blog-post-excerpt Poppins-Regular">{post.excerpt}</p>
                    <button
                      className="blog-read-more Poppins-Medium"
                      onClick={() => handleBlogClick(post)}
                    >
                      Continue Reading →
                    </button>
                  </div>
                </article>
              ))}

              {/* Load More Button */}
              <div className="load-more-container">
                {visibleBlogs < blogPosts.length && (
                  <div className="load-more-container">
                    <button
                      className="load-more-button Poppins-Medium"
                      onClick={loadMoreBlogs}
                    >
                      Load More
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Sidebar */}
          <aside className="blog-sidebar">

            {/* Categories */}
            <div className="sidebar-widget categories-widget">
              <h3 className="widget-title Baloo2-Medium">Categories</h3>
              <ul className="categories-list Poppins-Regular">
                {categories.map((category, index) => (
                  <li key={index}>
                    <a
                      href="#"
                      className="category-link"
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedCategory(category);
                      }}
                    >
                      {category}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Latest News */}
            <div className="sidebar-widget latest-news-widget">
              <h3 className="widget-title Baloo2-Medium">Latest News</h3>
              <div className="latest-news-list">
                {latestBlogs.map((news, index) => (
                  <div
                    key={index}
                    className="news-item"
                    onClick={() => handleNewsClick(news.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="news-image">
                      <img src={`${baseUrlForFiles}${news.image}`} alt={news.title} />
                    </div>
                    <div className="news-content">
                      <h4 className="news-title Poppins-Medium">{news.description}</h4>
                      <span className="news-date Poppins-Regular">{news.created_at}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Tags */}
            <div className="sidebar-widget tags-widget">
              <h3 className="widget-title Baloo2-Medium">Tags</h3>
              <div className="tags-container">
                {tags.map((tag, index) => (
                  <a
                    key={index}
                    href="#"
                    className="tag-item Poppins-Regular"
                    onClick={(e) => {
                      e.preventDefault();
                      handleTagClick(tag);
                    }}
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blogs;